import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "x_panel" };
const _hoisted_3 = { class: "x_title" };
const _hoisted_4 = { class: "clearfix" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = { class: "clearfix" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-close" }, null, -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", {
    class: "hidden-xs",
    style: { "color": "white" }
}, " Return", -1 /* HOISTED */);
const _hoisted_9 = { class: "x_content" };
const _hoisted_10 = { class: "clearfix top10" };
const _hoisted_11 = { class: "clearfix" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_13 = { class: "input-group top_search" };
const _hoisted_14 = { class: "input-group-btn" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_16 = [
    _hoisted_15
];
const _hoisted_17 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-4"
};
const _hoisted_18 = { class: "input-group top_search" };
const _hoisted_19 = { class: "col-xs-12 col-sm-12 col-md-2" };
const _hoisted_20 = { class: "input-group top_search" };
const _hoisted_21 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_22 = { class: "float-end mt-1" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-check-circle-o" }, null, -1 /* HOISTED */);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Authorize All", -1 /* HOISTED */);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-check-circle-o" }, null, -1 /* HOISTED */);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Unauthorize All", -1 /* HOISTED */);
const _hoisted_27 = { class: "col-xs-12 col-sm-12" };
const _hoisted_28 = { class: "card bg-white data-grid detached overflow-x-auto" };
const _hoisted_29 = { class: "table table-hover small bottom0 pw100" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tSystem\r\n\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "\r\n\t\t\t\t\t\t\t\t\t\t\tAuthorized\r\n\t\t\t\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_31 = { class: "clearfix" };
const _hoisted_32 = { class: "clearfix" };
const _hoisted_33 = { class: "float-start right5" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-map-marker" }, null, -1 /* HOISTED */);
const _hoisted_35 = { class: "text-center" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-check-circle-o" }, null, -1 /* HOISTED */);
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Authorized", -1 /* HOISTED */);
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-check-circle-o" }, null, -1 /* HOISTED */);
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Not Authorized", -1 /* HOISTED */);
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-check-circle-o" }, null, -1 /* HOISTED */);
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Authorized", -1 /* HOISTED */);
const _hoisted_42 = { key: 0 };
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("td", {
    colspan: "2",
    class: "text-center"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_44 = [
    _hoisted_43
];
const _hoisted_45 = { class: "data-grid-footer clearfix detached pw100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1 /* TEXT */),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_b_button, {
                                type: "button",
                                onClick: _ctx.finished,
                                variant: "secondary"
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_7,
                                    _hoisted_8
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                        ])
                    ])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_b_form_input, {
                                    modelValue: _ctx.query.keywords,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                    modelModifiers: { trim: true },
                                    type: "text",
                                    placeholder: "Search for...",
                                    onKeyup: _withKeys(_ctx.search, ["enter"]),
                                    required: ""
                                }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                                _createTextVNode(),
                                _createElementVNode("span", _hoisted_14, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-default",
                                        onClick: _cache[1] || (_cache[1] =
                                            //@ts-ignore
                                            (...args) => (_ctx.search && _ctx.search(...args)))
                                    }, _hoisted_16)
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        (_ctx.showSiteFilter)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_multiselect, {
                                        modelValue: _ctx.siteId,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.siteId) = $event)),
                                        options: _ctx.siteOptions,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Any site",
                                        class: "multiselect-small"
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options"])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.systemStatus,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.systemStatus) = $event)),
                                    options: _ctx.systemStatusOptions,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "All systems",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                (_ctx.hasSystemsToGrant())
                                    ? (_openBlock(), _createBlock(_component_b_button, {
                                        key: 0,
                                        type: "button",
                                        variant: "primary",
                                        class: "mb-0",
                                        onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.grantAll())),
                                        size: "sm"
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_23,
                                            _hoisted_24
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (_ctx.hasSystemsToRevoke())
                                    ? (_openBlock(), _createBlock(_component_b_button, {
                                        key: 1,
                                        type: "button",
                                        variant: "danger",
                                        class: "mb-0",
                                        onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.revokeAll())),
                                        size: "sm"
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_25,
                                            _hoisted_26
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _withDirectives(_createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("table", _hoisted_29, [
                                _hoisted_30,
                                _createTextVNode(),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", null, [
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_31, [
                                                    _createElementVNode("b", null, _toDisplayString(item.systemName), 1 /* TEXT */)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_32, [
                                                    _createElementVNode("div", _hoisted_33, [
                                                        _hoisted_34,
                                                        _createTextVNode(" " + _toDisplayString(item.siteName), 1 /* TEXT */)
                                                    ])
                                                ])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_35, [
                                                (item.hasAccessToCompanySystems)
                                                    ? _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                                                        key: 0,
                                                        type: "button",
                                                        variant: "primary",
                                                        title: "User has access to all systems for this company.",
                                                        size: "sm"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _hoisted_36,
                                                            _hoisted_37
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })), [
                                                        [
                                                            _directive_b_tooltip,
                                                            void 0,
                                                            void 0,
                                                            { hover: true }
                                                        ]
                                                    ])
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        (!item.hasAccessToSystem)
                                                            ? (_openBlock(), _createBlock(_component_b_button, {
                                                                key: 0,
                                                                type: "button",
                                                                variant: "danger",
                                                                onClick: ($event) => (_ctx.grant(item)),
                                                                size: "sm"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_38,
                                                                    _hoisted_39
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                                            : _createCommentVNode("v-if", true),
                                                        _createTextVNode(),
                                                        (item.hasAccessToSystem)
                                                            ? (_openBlock(), _createBlock(_component_b_button, {
                                                                key: 1,
                                                                type: "button",
                                                                variant: "primary",
                                                                onClick: ($event) => (_ctx.revoke(item)),
                                                                size: "sm"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_40,
                                                                    _hoisted_41
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                                            : _createCommentVNode("v-if", true)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                            ])
                                        ]));
                                    }), 256 /* UNKEYED_FRAGMENT */))
                                ]),
                                _createTextVNode(),
                                _createElementVNode("tfoot", null, [
                                    (_ctx.noData)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_42, _hoisted_44))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_b_pagination, {
                                class: "float-end",
                                modelValue: _ctx.query.pageNo,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.query.pageNo) = $event)),
                                "per-page": _ctx.query.pageSize,
                                "total-rows": _ctx.data.recordCount,
                                "hide-ellipsis": true,
                                disabled: _ctx.working
                            }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                        ])
                    ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.searchAttempted]
                    ])
                ])
            ])
        ])
    ]));
}
